module.exports = __webpack_public_path__ + "img/spinner.47d262a.png";